import {Component, Input, OnInit} from '@angular/core';

import { Driver } from '@commons/models/domain/Driver';
import {StringService} from "@shared/services/string.service";

@Component({
  selector: 'wm-driver-list-item',
  templateUrl: './driver-list-item.component.html',
})
export class DriverListItemComponent implements OnInit {

  @Input() driver!: Driver;
  @Input() isSelected!: boolean;

  get initials(): string {
    const result = this.driver.FN[0]?.toUpperCase() + ' ' + this.driver.LN[0].toUpperCase();
    return result;
  }

  get fullName(): string {
    return this.stringService.truncate(this.driver.FN + ' ' + this.driver.LN);
  }

  get phone(): string {
    let result = this.driver.CN?.length > 0 ? this.driver.CN : this.driver.Pn;
    return this.stringService.truncate(result);
  }

  get email(): string {
    return this.stringService.truncate(this.driver.Em);
  }

  constructor(
    private stringService: StringService
  ) { }

  ngOnInit(): void {
  }

}
